import React from 'react';
import {
  CheckboxContainer,
  CheckboxWrapper,
  ItemUpdateInputsContainer,
  ItemUpdateInputsWrapper,
  ItemUpdateSection,
  ItemUpdateText,
  ItemUpdateTextWrapper,
  TextBold
} from './styles';
import { DateField } from '@gerdau/hefesto-mais-web';
import { Checkbox, TextArea, TextField } from '@gerdau/hefesto';
import moment from 'moment';
import { TooltipDetail } from '../OrderDetail/TooltipDetail';
import { addBusinessDays } from '../../LongSteelOrders/OrdersTabs/Tables/OpenOrdersTable/UpdateOrder/utils';
import DateInput from '../../../../components/Purchase/DateInput';
import QuantityInput from '../../../../components/Purchase/QuantityInput';
import { StateProps } from '.';
import { getVolumeValueToShow } from '../../../../utils/measureUnit';

export const OrderItemUpdate = ({
  data,
  updateState
}: {
  data: StateProps;
  updateState: React.Dispatch<React.SetStateAction<StateProps[]>>;
}) => {
  const measureUnit =
    data.item.quantities.requestedMeasureUnit &&
    data.item?.measureUnits &&
    data.item.measureUnits?.find(
      (item) => item.measure === data.item.quantities.requestedMeasureUnit
    );
  return (
    <ItemUpdateSection key={data.item.id}>
      <ItemUpdateTextWrapper>
        <TextBold>{data.item.sku}</TextBold>
        <ItemUpdateText>{data.item.materialDescription}</ItemUpdateText>
      </ItemUpdateTextWrapper>

      <CheckboxContainer>
        <CheckboxWrapper>
          <Checkbox
            label="Quantidade"
            checked={data.checkbox.quantity}
            name="checkboxQuantity"
            onChange={() =>
              updateState((prev) =>
                prev.map((itm) =>
                  itm.item.id === data.item.id
                    ? {
                        ...itm,
                        checkbox: {
                          ...itm.checkbox,
                          quantity: !itm.checkbox.quantity
                        }
                      }
                    : itm
                )
              )
            }
          />

          <TooltipDetail titleTooltip="A nova quantidade deverá ser baseada no saldo restante e no múltiplo do produto" />
        </CheckboxWrapper>
        <CheckboxWrapper>
          <Checkbox
            label="Data desejada"
            checked={data.checkbox.desiredDate}
            name="checkBoxdesiredDate"
            onChange={() =>
              updateState((prev) =>
                prev.map((itm) =>
                  itm.item.id === data.item.id
                    ? {
                        ...itm,
                        checkbox: {
                          ...itm.checkbox,
                          desiredDate: !itm.checkbox.desiredDate
                        }
                      }
                    : itm
                )
              )
            }
          />

          <TooltipDetail titleTooltip="A nova data desejada deverá ser a partir de três dias úteis" />
        </CheckboxWrapper>
        <CheckboxWrapper>
          <Checkbox
            label="Outras alterações"
            checked={data.checkbox.other}
            name="checkboxOther"
            onChange={() =>
              updateState((prev) =>
                prev.map((itm) =>
                  itm.item.id === data.item.id
                    ? {
                        ...itm,
                        checkbox: {
                          ...itm.checkbox,
                          other: !itm.checkbox.other
                        }
                      }
                    : itm
                )
              )
            }
          />
        </CheckboxWrapper>
      </CheckboxContainer>

      <ItemUpdateInputsContainer>
        <ItemUpdateInputsWrapper>
          <TextField
            label="Quantidade"
            maxLength={2}
            name="quantity"
            value={getVolumeValueToShow(
              data?.item?.quantities?.requestedQuantity,
              data?.item?.quantities?.requestedMeasureUnit
            )}
            readOnly={true}
          />

          <DateField
            onChange={() => null}
            selected={
              data.item.requestedDate
                ? moment(data.item.requestedDate).toDate()
                : undefined
            }
            label="Data desejada"
            name="desiredDate"
            readOnly={true}
          />

          <QuantityInput
            label="Nova quantidade"
            onChange={(e) =>
              updateState((prev) =>
                prev.map((itm) =>
                  itm.item.id === data.item.id
                    ? {
                        ...itm,
                        values: {
                          ...itm.values,
                          quantity: e
                        }
                      }
                    : itm
                )
              )
            }
            width="auto"
            value={data.values.quantity ?? ''}
            measureUnit={measureUnit}
            readOnly={!data.checkbox.quantity || !measureUnit}
          />

          <DateInput
            label="Nova data desejada"
            minimumDate={addBusinessDays(3)}
            onSelectDate={(date: string) =>
              updateState((prev) =>
                prev.map((itm) =>
                  itm.item.id === data.item.id
                    ? {
                        ...itm,
                        values: {
                          ...itm.values,
                          desiredDate: date
                        }
                      }
                    : itm
                )
              )
            }
            value={data.values.desiredDate}
            readOnly={!data.checkbox.desiredDate}
          />
        </ItemUpdateInputsWrapper>

        <TextArea
          name="otherUpdatesNote"
          label="Outras alterações"
          value={data.values.other}
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
            updateState((prev) =>
              prev.map((itm) =>
                itm.item.id === data.item.id
                  ? {
                      ...itm,
                      values: {
                        ...itm.values,
                        other: e.target.value
                      }
                    }
                  : itm
              )
            )
          }
          resizable={false}
          maxLength={500}
          placeholder="Descreva o pedido de alteração"
          readOnly={!data.checkbox.other}
        />
      </ItemUpdateInputsContainer>
    </ItemUpdateSection>
  );
};
